import React from 'react';
import './Button.css';

/**
 * Download Icon SVG Component
 */
const DownloadIcon = ({ size = 18 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

/**
 * DownloadButton Component
 * Button specifically styled for download actions (PDF, files, etc.)
 * 
 * @param {function} onClick - Click handler
 * @param {ReactNode} children - Button content (default: icon only)
 * @param {string} size - Button size: 'small'|'medium'|'large' (default: 'medium')
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional CSS classes
 * @param {boolean} iconOnly - Whether to show only icon (default: true)
 */
const DownloadButton = ({ 
  onClick, 
  children, 
  size = 'medium', 
  disabled = false, 
  className = '',
  iconOnly = true
}) => {
  const sizeClass = size === 'large' ? 'btn-large' : size === 'small' ? 'btn-small' : '';
  const iconSize = size === 'large' ? 18 : size === 'small' ? 14 : 16;
  
  const defaultContent = <DownloadIcon size={iconSize} />;
  
  return (
    <button
      className={`btn btn-primary download-button ${iconOnly ? 'btn-icon-only' : ''} ${sizeClass} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label={iconOnly ? 'Download PDF' : undefined}
    >
      {children || defaultContent}
    </button>
  );
};

export default DownloadButton;

